import styled from 'styled-components';
import type { IBackgroundApplicationSettings } from '../../types/models/ISectionSettings';

interface StyledSectionBackgroundProps {
  // Landscape image; the portrait one is swapped in by the media query below
  $backgroundSettings: IBackgroundApplicationSettings;
  $portraitBackgroundImage?: string;
}

export const StyledSectionBackground = styled.div<StyledSectionBackgroundProps>`
  ${({ $backgroundSettings, $portraitBackgroundImage }) => {
    if (!$backgroundSettings.hasBackground || !$backgroundSettings.backgroundImage) {
      return '';
    }

    return `
      ${$backgroundSettings.backgroundColor ? `background-color: ${$backgroundSettings.backgroundColor};` : ''}
      background-image: url(${$backgroundSettings.backgroundImage});
      --section-background-image: url(${$backgroundSettings.backgroundImage});
      ${
        $portraitBackgroundImage
          ? `@media (orientation: portrait) {
        background-image: url(${$portraitBackgroundImage});
        --section-background-image: url(${$portraitBackgroundImage});
      }`
          : ''
      }
    `;
  }}
`;

StyledSectionBackground.displayName = 'StyledSectionBackground';
